import { useEffect } from 'react';
import { Tooltip } from 'bootstrap';
import { DollarSign, Percent, TrendingUp } from 'react-feather';
import useTranslation from '../hooks/translations';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function IncomesDistributionList({ sourceType, data }) {
  const translations = useTranslation();

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((el) => new Tooltip(el));
  }, []);

  // Split into categories
  const defaultIncomes = data.filter((item) => item.isDefault);
  const otherIncomes = data.filter((item) => !item.isDefault);

  const renderSection = (items, sectionTitle) => (
    <>
      <div className="text-muted small fw-bold text-uppercase border-top pt-3 pb-1">
        {sectionTitle}
      </div>

      {items.map((item, idx) => (
        <div
          key={idx}
          className="d-flex align-items-center justify-content-between px-0 py-2 small border-top"
        >
          <div className="flex-grow-1 d-flex align-items-center">
            <FontAwesomeIcon icon="circle"
                             className="fa-sm me-1"
                             color={item.color}/>
            {item.label}
          </div>
          <div className="text-center" style={{ width: '80px' }}>
            {item.percentageOfIncome}%
          </div>
          <div className="text-end d-none d-md-block" style={{ width: '140px' }}>
            {item.nominalValue}
          </div>
        </div>
      ))}
    </>
  );

  return (
    <div className="list-group list-group-flush">
      {/* Header row */}
      <div className="d-flex justify-content-between px-0 py-2 text-muted small fw-bold text-uppercase">
        <div className="flex-grow-1">
          {sourceType}
        </div>
        <div className="text-center" style={{ width: '80px' }}>
          <span data-bs-toggle="tooltip" title={translations.percentageOfIncome}>
            <TrendingUp className="feather-m" />
            <Percent className="feather-sm" />
          </span>
        </div>
        <div className="text-end d-none d-md-block" style={{ width: '140px' }}>
          <DollarSign className="feather-m" data-bs-toggle="tooltip" title={translations.nominalValue} />
        </div>
      </div>
      {!!defaultIncomes.length && renderSection(defaultIncomes, translations.defaultIncomes)}
      {!!otherIncomes.length && renderSection(otherIncomes, translations.otherIncomes)}
    </div>
  );
}

export default IncomesDistributionList;
